export default theme => ({
  container: {
    overflowY: 'auto',
    overflowX: 'hidden',
    height: '100%',
    padding: 1,
    flex: 1,
    display: 'flex',
    flexDirection: 'column',
    maxHeight: 'calc(100vh - 150px)',
  },
  cardContent: {
    padding: '0',
  },
  cardHeader: {
    padding: '12px',
    backgroundColor: '#fafafa',
  },
  cardHeaderTitle: {
    fontSize: '1rem',
    fontWeight: '700',
    textAlign: 'left',
    color: '#var(--jmi-blue)',
  },

  tableColumn: {
    border: '1px solid gray',
    flex: 1,
    alignSelf: 'stretch',
    marginRight: 5,
    marginLeft: 5,
    overflow: 'auto',
  },

  tableColumnSmall: {
    border: '1px solid gray',
    flex: 0.5,
    alignSelf: 'stretch',
    marginRight: 5,
    marginLeft: 5,
    overflow: 'auto',
  },

  tableColumnMedium: {
    border: '1px solid gray',
    flex: 0.75,
    alignSelf: 'stretch',
    marginRight: 5,
    marginLeft: 5,
    overflow: 'auto',
  },

  tableColumnHeader: {
    zIndex: 1,
    position: 'sticky',
    top: 0,
    backgroundColor: 'white',
    fontSize: '1.2vw',
    paddingTop: 15,
    paddingBottom: 15,
    borderStyle: 'none',
    borderBottom: '1px solid gray',
  },

  tableColumnInputHeader: {
    zIndex: 1,
    position: 'sticky',
    top: 0,
    display: 'flex	',
    flexDirection: 'row',
    width: 'calc(100%)',

    //height: '51px',
    backgroundColor: 'white',
    borderStyle: 'none',
    borderBottom: '1px solid gray',
  },

  inputHeader: {
    top: 0,
    backgroundColor: 'white',
    paddingTop: 15,
    paddingBottom: 16.8,
    width: 'calc(100% - 6px)',
    fontSize: '1.2vw',
    textAlign: 'Center',
    borderStyle: 'none',
    //borderBottom: '1px solid gray',
  },

  searchIcon: {
    position: 'absolute',
    top: '0',
    height: 'calc(100%)',
    right: 0,
    marginRight: '15px',
    fontSize: '1.2vw',
    //width: 'calc(100%)',
  },

  table: {
    flex: 1,
    display: 'flex',
    flexDirection: 'row',
    overflow: 'auto',
  },

  columnTile: {
    marginTop: 5,
    marginBottom: 5,
    padding: 10,
    // textAlign: 'left',
    cursor: 'pointer',
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
    borderLeft: '3px solid transparent',

    '&:hover': {
      backgroundColor: '#ccc',
    },
  },

  columnDisabled: {
    opacity: 0.6,
    pointerEvents: 'none',
  },

  /** Muted row without pointer-events: none — allows Tooltips on disabled IQ-only controls */
  columnMutedNoPointerBlock: {
    opacity: 0.6,
  },

  columnTileSelected: {
    backgroundColor: '#ccc',
    color: 'black',

    '&:hover': {
      backgroundColor: '#eee',
      color: 'black',
    },
  },

  columnTileHasOrderRecommendation: {
    borderLeft: '3px solid #5D0',
  },

  recommendationFormContainer: {
    padding: 10,
    paddingTop: 25,
  },

  removeButton: {
    marginRight: '8px',
    backgroundColor: '#f44336',
    color: '#fff',
    '&:hover': {
      background: '#d2190b',
    },
  },

  activeRecommendationsContainer: {
    maxHeight: 250,
    overflow: 'auto',
    padding: 10,
    // display: 'flex',
    // flexDirection: 'column',
  },
  activeRecommendationListItem: {
    display: 'flex',

    borderBottom: '1px solid #ccc',

    '&:last-of-type': {
      borderBottom: 'none',
    },
    // flexDirection: 'row',
    // justifyContent: 'space-between',

    // alignSelf: 'stretch',
    // overflow: 'auto',
  },

  activeRecommendationListItemColumn: {
    flex: 1,
    minWidth: 0,
    padding: 10,
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'flex-start',
    alignItems: 'center',

    // recommendation line
    '&:last-of-type': {
      flex: 3,
    },
  },

  recommendationTooltipContent: {
    whiteSpace: 'normal',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
  },

  input: {
    background: 'transparent',
    '&:focus': {
      outline: 'none',
    },
    alignSelf: 'stretch',
  },

  textInput: {
    // fontSize: 18,

    border: '1px solid #aaa',
    borderRadius: 5,
    padding: 10,
  },
  disabledText: {
    // color: '#888',
    opacity: 0.2,
  },

  textLabelError: {
    color: 'red',
    fontWeight: 'bold',
  },
  textInputError: {
    borderBottom: '2px solid red',
  },

  clientConfigAddRemoveIcon: {
    borderRadius: '50%',
    padding: 5,
    cursor: 'pointer',

    '&:hover': {
      background: 'rgba(0,0,0,0.1)',
    },

    '&:active': {
      background: 'rgba(0,0,0,0.2)',
    },
  },
});
